import { clsx } from "clsx"
import { ReactNode } from "react"
import { FormattedMessage } from "react-intl"
import Pagination, { PaginationProps } from "."

interface Props extends PaginationProps {
  dataTotal: number
  leftSection?: ReactNode
  className?: string
}
export const TablePagination = ({ dataTotal, perPage = 5, leftSection, className, ...props }: Props) => {
  let to = (props.currentPage + 1) * perPage
  if (to > dataTotal) to = dataTotal
  if (dataTotal === 0) return null
  return (
    <div className={clsx("flex items-center justify-between mb-10 flex-col gap-3 md:flex-row md:gap-0", className)}>
      <div className="flex gap-2.5 items-center">
        {leftSection}
        <FormattedMessage id="table_info" values={{ from: props.currentPage * perPage + 1, to, count: dataTotal }} />
      </div>
      <Pagination currentPage={props.currentPage + 1} perPage={perPage} totalPages={props.totalPages} onPageChange={props.onPageChange} />
    </div>
  )
}
